define.alias("ember-math-helpers/helpers/acosh", "preview-grid/helpers/acosh");